import { Withholding } from "./withholding";
import { WithholdingDivisionArea } from "./withholding-division-area";


export class WithholdingConfiguration {

    id: number = 0;
    withholding: Withholding = new Withholding();
    description!: string;
    formula!: string;
    active: boolean = false;

    withholdingDivisionAreaList: WithholdingDivisionArea[] = [];
    
}